import {
	Component, Input, OnDestroy, OnChanges, AfterViewInit, ViewChild, SimpleChanges, Output, EventEmitter,
	ChangeDetectorRef, OnInit, ElementRef
} from '@angular/core';


@Component({
	selector: 'single-port-enable-disable-dialog',
	templateUrl: './single-port-enable-disable-dialog.component.html',
	styleUrls: ['./single-port-enable-disable-dialog.component.scss']
})
export class SinglePortEnableDisableDialogComponent implements OnChanges, OnDestroy, OnInit, AfterViewInit {

	@Input()
	public deviceGuid: string;

	@Input()
	public ifIndex: number;

	@Input()
	public visible: boolean;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	constructor(private changeDetector: ChangeDetectorRef) {

		this.deviceGuid = undefined;
		this.visible = false;
		this.visibleChange = new EventEmitter<boolean>();
	}

	public ngOnChanges(changes: SimpleChanges): void {

	}

	public ngOnInit(): void {

	}

	public ngAfterViewInit(): void {

	}

	public ngOnDestroy(): void {

	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	public onCloseClicked(): void {
		this.hide();
	}

	public onHide(): void {
		this.hide();
	}

}
